module.exports = __webpack_public_path__ + "static/media/Bike.c8d91622.svg";